/** @lintignore */
import { Tooltip, TooltipProps } from 'antd';
import { FC } from 'react';

export const CustomTooltip: FC<TooltipProps> = (props) => {
    return (
        <Tooltip
            {...props}
            styles={{
                ...props.styles,
                body: {
                    ...props.styles?.body,
                    padding: 'var(--spacing-xs)',
                    color: 'black',
                },
            }}
        />
    );
};
